import React from "react";
import { Box } from "@mui/material";
import { DOTTED_LINE } from "my-tax/constants";

interface MyTaxDependentsInfoTableRowProps {
  dependentQuality?: string;
  name: string;
  taxNumber?: string;
  dependencyTitle?: string;
  changeDate?: string;
  placeOfBirth?: string;
  dateOfBirth?: string;
  variant?: "default" | "combined";
}

const LAYOUT_CONFIG = {
  default: {
    taxNumber: { width: "166px", marginLeft: undefined as string | undefined },
    name: { width: "200px", marginLeft: "10px" },
    dependentQuality: { width: "50px", marginLeft: undefined as string | undefined },
    dependencyTitle: { width: "50px", marginLeft: "30px" },
    changeDate: { width: "130px", marginLeft: "20px" },
    showBirthInfo: false as const,
    birthInfo: undefined as { width: string; marginLeft: string } | undefined,
  },
  combined: {
    taxNumber: { width: "120px", marginLeft: "5px" },
    name: { width: "140px", marginLeft: undefined as string | undefined },
    dependentQuality: { width: "40px", marginLeft: undefined as string | undefined },
    dependencyTitle: { width: "40px", marginLeft: "10px" },
    changeDate: { width: "40px", marginLeft: "10px" },
    showBirthInfo: true as const,
    birthInfo: { width: "150px", marginLeft: "10px" },
  },
} as const;

export const MyTaxDependentsInfoTableRow: React.FC<
  MyTaxDependentsInfoTableRowProps
> = ({
  dependentQuality,
  name,
  taxNumber,
  dependencyTitle,
  changeDate,
  placeOfBirth,
  dateOfBirth,
  variant = "default"
}) => {
    const config = LAYOUT_CONFIG[variant];

    const formattedBirthDate = dateOfBirth ? new Date(dateOfBirth).toLocaleDateString() : "";

    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-around"
        style={{ margin: "8px 0px 8px 0px", fontSize: "15px" }}
      >
        <Box width={config.taxNumber.width} textAlign="center" marginLeft={config.taxNumber.marginLeft}>
          {taxNumber ? taxNumber : DOTTED_LINE}
        </Box>
        <Box width={config.name.width} textAlign="center" marginLeft={config.name.marginLeft}>
          {name}
        </Box>
        <Box width={config.dependentQuality.width} textAlign="center" marginLeft={config.dependentQuality.marginLeft}>
          {dependentQuality}
        </Box>
        <Box width={config.dependencyTitle.width} textAlign="center" marginLeft={config.dependencyTitle.marginLeft}>
          {dependencyTitle}
        </Box>
        <Box width={config.changeDate.width} textAlign="center" marginLeft={config.changeDate.marginLeft}>
          {variant === "combined"
            ? changeDate || ""
            : changeDate ? new Date(changeDate).toLocaleDateString() : ""
          }
        </Box>
        {config.showBirthInfo && config.birthInfo && (
          <Box width={config.birthInfo.width} textAlign="center" marginLeft={config.birthInfo.marginLeft}>
            {placeOfBirth && formattedBirthDate
              ? `${placeOfBirth}, ${formattedBirthDate}`
              : placeOfBirth || formattedBirthDate || DOTTED_LINE}
          </Box>
        )}
      </Box>
    );
  };

export default MyTaxDependentsInfoTableRow;
